import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export const authToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlrZXkiOiJjNDk0NzY0YS0xZThkLTRkMzEtOWFjZi1hYWM2ZTEwNWVhZTYiLCJwZXJtaXNzaW9ucyI6WyJhbGxvd19qb2luIl0sImlhdCI6MTcyNTk0Mzk0NywiZXhwIjoxODgzNzMxOTQ3fQ.V4ltz2lFsjvBd5HkuRDvKy__KP5sBnkz5SUCoewuKUs";
export const createMeeting = async () => {

  try {
    const res = await fetch(`https://api.videosdk.live/v2/rooms`, {
      method: "POST",
      headers: {
        authorization: `${authToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    });
    <ToastContainer />
    const { roomId } = await res.json();
    return roomId;
  }
  catch (err) {
    toast.error(err.message)
    console.log(err)
  }
};
